function personNameHaystacks(person) {
  const displayName = (person.display_name || '').toLowerCase();
  const firstName = (person.first_name || '').toLowerCase();
  const lastName = (person.last_name || '').toLowerCase();
  const fullName = `${firstName} ${lastName}`.trim();

  return [displayName, firstName, lastName, fullName].filter(Boolean);
}

export function personMatchesNameQuery(person, query) {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return personNameHaystacks(person).some((haystack) => haystack.includes(q));
}

export function filterPeopleByName(people, query) {
  const q = query.trim();
  if (!q) return people;
  return people.filter((person) => personMatchesNameQuery(person, q));
}

/** @deprecated Use filterPeopleByName */
export function filterPeopleByDisplayName(people, query) {
  return filterPeopleByName(people, query);
}
